import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter } from 'react-router-dom';

import { history } from './redux/store';
import Navbar from './components/TopBar';
import {
  // CustomerSupport,
  DocumentTitle,
  ErrorBoundary,
  CookiesConsent,
} from './components';
import AdminDashboard from './screens/Admin';
import { AlertError } from './components/ErrorMessage';
import LightboxContainer from './components/Lightbox';
import Signup from './screens/Signup';

import { activateGoogleOptimize } from './redux/actions/analyticsEventActions';
import { initUserInfo, loginSessionExpire, storeToken } from './redux/actions/authActions';
import { setUpSentry } from './config';
import { inProduction, isUserLoggedIn, scrollIntoView } from './lib/utils';

import { AsyncPolices, AsyncCareer } from './AsyncApp';

import BookingsDashboard from './screens/BookingsDashboard';
import OnboardingForm from './screens/OnboardingForm/OnboardingForm';
import Landing from './screens/Landing';
import LoginContainer from './redux/containers/LoginContainer';
import SessionExpire from './screens/LoginSessionExpire';
import AsyncTrekHome from './screens/Trek';
import Explore from './screens/Explore';
import Profile from './screens/Profile';
import PlaceDetails from './screens/Places';
import PlaceListings from './screens/Places/Listings';
import Error404 from './screens/404/';
import GuideListings from './screens/GuideListings';
// import FlightsScreen from './screens/Flights';
import ScrollToTopOnMount from './components/ScrollToTopOnMount';
import Lodge from './screens/Lodge';
import Footer from './screens/Landing/Footer';
import Partners from './screens/Partners';

import { lodgeId, userId } from './constants/idRegex';
import CartHome from './screens/Cart';
import TransportationHome from './screens/Transportation';

import './scss/App.css';
type Props = {
  storeToken: () => void,
  initUserInfo: () => void,
  loginSessionExpire: () => void,
  activateGoogleOptimize: () => void,
  userId: string,
};

class App extends Component<Props> {
  componentDidMount() {
    this.init();
    this.scrollToHashLink();
    this.props.activateGoogleOptimize();
  }

  init = () => {
    const { token, roles, id } = localStorage;

    if (inProduction()) setUpSentry();

    if (isUserLoggedIn()) {
      const { initUserInfo, userId, storeToken } = this.props;
      const userDataHasArrivedFromSSR = Boolean(userId);

      if (!userDataHasArrivedFromSSR) {
        storeToken(token, roles, id);
        initUserInfo();
      }
    }
  };

  componentWillUnmount() {
    this.clearTimeouts();
  }

  isLandingPage = props => props.location.pathname === '/';

  dontRenderInLandingPage = (Component, props) =>
    this.isLandingPage(props) ? null : <Component />;

  scrollToHashLink = () => {
    const { hash } = history.location;
    if (hash) {
      this.scrollToHashTimeoutId = setTimeout(() => scrollIntoView(hash), 1000);
    }
  };

  clearTimeouts = () => {
    if (this.scrollToHashTimeoutId) clearTimeout(this.scrollToHashTimeoutId);
  };

  render() {
    return (
      <div className="App">
        <ErrorBoundary errorInAppLevel>
          <Route path="/" render={props => this.dontRenderInLandingPage(Navbar, props)} />
          <Route
            path="/"
            render={props => this.dontRenderInLandingPage(LightboxContainer, props)}
          />
          <DocumentTitle />
          <LoginContainer />
          <SessionExpire />
          <AlertError />
          <ScrollToTopOnMount />
          {/* <CustomerSupport /> */}
          <Route exact path="/" render={() => <CookiesConsent />} />
          <Route exact path="/" render={() => <Landing />} />
          <Switch>
            <Route path="/explore" render={() => <Explore />} />
            <Route path="/treks" render={() => <AsyncTrekHome />} />
            <Route path="/places" render={() => <PlaceListings />} />
            <Route path="/guides" render={() => <GuideListings />} />
            <Route
              path="/onboarding-form"
              render={props => <OnboardingForm {...props} />}
            />
            <Route
              exact
              path="/:placeName.:placeId.:regionName-region"
              render={props => <PlaceDetails {...props} />}
            />
            <Route
              path={`/:lodgeName.:lodgeId(${lodgeId}).:placeName-lodges`}
              component={Lodge.DetailsAndPayment}
            />
            <Route path="/cart" component={CartHome} />
            <Route path="/careers" render={() => <AsyncCareer />} />
            <Route path="/policies" render={() => <AsyncPolices />} />
            <Route path="/lodges" component={Lodge.SearchAndListings} />
            <Route path="/transportation" component={TransportationHome} />
            <Route
              path={`/:username.:userId(${userId})`}
              render={props => <Profile {...props} />}
            />
            <Route exact path="/admin" render={props => <AdminDashboard {...props} />} />
            <Route
              exact
              path="/admin/bookings"
              render={props => <BookingsDashboard {...props} />}
            />
            <Route path="/signup" render={props => <Signup {...props} />} />
            <Route path="/partners" component={Partners} />
            <Route render={props => (this.isLandingPage(props) ? null : <Error404 />)} />
          </Switch>
          <Footer />
        </ErrorBoundary>
      </div>
    );
  }
}

export default withRouter(
  connect(
    ({ user }) => ({
      userId: user.userId,
    }),
    {
      storeToken,
      initUserInfo,
      loginSessionExpire,
      activateGoogleOptimize,
    }
  )(App)
);



// WEBPACK FOOTER //
// ./src/App.js